import SubscriptionIcon from '@mui/icons-material/AssignmentOutlined';
import SubscriptionList from './SubscriptionList';

export * from './queries';

export default {
    list: SubscriptionList,
    icon: SubscriptionIcon,
};
